export const navLinks = [
  { label: '官方入口', href: '#address' },
  { label: '最新地址', href: '#address' },
  { label: 'APP下载', href: '#app' },
  { label: '今日热议', href: '#trending' },
  { label: '吃瓜讨论', href: '#discussion' },
  { label: '新手指引', href: '#guide' },
];

export const noticeText =
  '本站仅整理官方入口与地址指引，不存储、不传播任何内容 · 请认准官方通道，谨防仿冒站点 · 地址每 2 小时自动校验一次';

export const heroStats = [
  { label: '已收录通道', value: '12', suffix: '条' },
  { label: '地址更新频率', value: '每2h', suffix: '' },
  { label: '今日访问', value: '86.4', suffix: '万' },
];

export const channelStatus = {
  online: 3,
  backup: 2,
  maintenance: 1,
  updatedAt: '2026-10-10 09:00',
};

export const addressChannels = [
  {
    id: 'line-main',
    name: '主站线路 · 官方通道',
    tag: '推荐',
    desc: '官方首选入口，速度稳定，支持网页与 APP 同账号进入。',
    status: 'online',
    latency: 62,
    url: 'https://入口主站.example/main',
  },
  {
    id: 'line-fast',
    name: '高速线路 · 电信优化',
    tag: '加速',
    desc: '电信网络优先调度，加载更快，适合宽带直连。',
    status: 'online',
    latency: 48,
    url: 'https://入口加速.example/fast',
  },
  {
    id: 'line-mobile',
    name: '移动线路 · 手机端',
    tag: '移动',
    desc: '针对移动网络优化，弱信号下也能稳定打开。',
    status: 'online',
    latency: 74,
    url: 'https://入口移动.example/mobile',
  },
  {
    id: 'line-backup-a',
    name: '备用线路 A',
    tag: '备用',
    desc: '主线路拥堵时自动切换，建议收藏备用地址。',
    status: 'backup',
    latency: 96,
    url: 'https://备用地址.example/a',
  },
  {
    id: 'line-backup-b',
    name: '备用线路 B',
    tag: '备用',
    desc: '海外节点备用通道，适合境外访问场景。',
    status: 'backup',
    latency: 128,
    url: 'https://备用地址.example/b',
  },
  {
    id: 'line-maint',
    name: '旧版线路 · 升级中',
    tag: '维护',
    desc: '正在升级维护，暂时无法访问，请改用其他线路。',
    status: 'maintenance',
    latency: 0,
    url: 'https://旧版线路.example/legacy',
  },
] as const;

export const addressTips = [
  '优先选择标注“推荐 / 加速”的线路，速度更稳定。',
  '遇到打不开先刷新，或切到备用线路 A / B。',
  '建议把本页加入书签，地址变动可随时回来查。',
];

export const downloadSteps = [
  {
    step: '01',
    title: '选择下载方式',
    desc: '安卓用户下载安装包，iOS 用户通过描述文件或网页版添加到桌面。',
  },
  {
    step: '02',
    title: '允许安装与信任',
    desc: '下载完成后按系统提示允许安装，iOS 需在设置中完成信任。',
  },
  {
    step: '03',
    title: '登录并加入书签',
    desc: '打开 APP 用同一账号登录，即可同步网页版收藏与浏览记录。',
  },
];

export const trendingItems = [
  {
    rank: 1,
    title: '导播误切镜头名场面合集',
    summary: '直播现场连续三次切错画面，网友直呼太过真实，讨论量半小时翻倍。',
    heat: '328万',
    comments: 1284,
    type: 'hot',
  },
  {
    rank: 2,
    title: '通勤地铁偶遇名角路透',
    summary: '路人随手一拍引来数千跟帖，评论区的按图索骥比瓜本身还精彩。',
    heat: '255万',
    comments: 976,
    type: 'hot',
  },
  {
    rank: 3,
    title: '新剧发布会花絮流出',
    summary: '主创互动细节被逐帧解析，粉丝与路人观点两极，话题仍在发酵。',
    heat: '198万',
    comments: 742,
    type: 'new',
  },
  {
    rank: 4,
    title: '综艺剪辑争议回应',
    summary: '节目组发布说明澄清剪辑节奏，评论区开启大型复盘现场。',
    heat: '166万',
    comments: 631,
    type: 'hot',
  },
  {
    rank: 5,
    title: '体育圈赛后采访名场面',
    summary: '一句临场回应被做成表情包，转发量在几小时内迅速破万。',
    heat: '142万',
    comments: 588,
    type: 'new',
  },
  {
    rank: 6,
    title: '老牌综艺重聚预告',
    summary: '原班人马同框画面曝光，勾起一波回忆杀，评论区集体许愿。',
    heat: '121万',
    comments: 466,
    type: 'new',
  },
  {
    rank: 7,
    title: '直播间口误瞬间盘点',
    summary: '主播连麦时脱口而出的一句话，让弹幕瞬间刷屏，成为当晚笑点。',
    heat: '98万',
    comments: 372,
    type: 'hot',
  },
  {
    rank: 8,
    title: '影迷二创混剪登上热门',
    summary: '网友用旧素材剪出新剧情，技术与脑洞齐飞，评论区求教程。',
    heat: '76万',
    comments: 289,
    type: 'new',
  },
] as const;

export const trendingTags = [
  '直播现场',
  '路透细节',
  '综艺剪辑',
  '赛后采访',
  '回忆杀',
  '二创混剪',
  '表情包',
  '评论区复盘',
];

export const commentItems = [
  {
    id: 'c1',
    user: '瓜田第一排',
    tone: 'primary',
    time: '10 分钟前',
    text: '主线路确实稳，昨天备用线路一直转圈，切回主站一秒就进去了。',
    likes: 128,
    replies: 12,
  },
  {
    id: 'c2',
    user: '摸鱼看热闹',
    tone: 'accent',
    time: '32 分钟前',
    text: '建议把这一页存书签，地址一换我每次都能第一时间找到入口，省事。',
    likes: 96,
    replies: 8,
  },
  {
    id: 'c3',
    user: '夜猫子小分队',
    tone: 'secondary',
    time: '1 小时前',
    text: 'APP 端加载明显比网页快，登录后收藏也是同步的，体验还行。',
    likes: 74,
    replies: 15,
  },
  {
    id: 'c4',
    user: '评论区观察员',
    tone: 'primary',
    time: '2 小时前',
    text: '就爱看复盘，比瓜本身还带劲，希望热门榜能一直保持更新。',
    likes: 65,
    replies: 6,
  },
  {
    id: 'c5',
    user: '低调进场',
    tone: 'accent',
    time: '3 小时前',
    text: '按步骤一步步来基本不会出错，新手照做就行，不用来回折腾。',
    likes: 52,
    replies: 4,
  },
  {
    id: 'c6',
    user: '手滑青年',
    tone: 'secondary',
    time: '4 小时前',
    text: '第一次用的时候复制按钮找半天，现在顺手多了，体验有进步。',
    likes: 41,
    replies: 9,
  },
] as const;

export const faqItems = [
  {
    q: '官网入口打不开怎么办？',
    a: '先刷新页面并切换网络；仍无法访问时，请改用备用线路 A / B。本页地址栏会持续校验，打不开的线路会标注为维护中。',
  },
  {
    q: 'APP 和网页版有什么区别？',
    a: '两者账号互通，APP 端加载更稳定、支持后台更新；网页版免安装、随开随用，适合临时访问。',
  },
  {
    q: '怎么确认自己进的是官方通道？',
    a: '从本页标注“推荐 / 加速”的官方线路进入即可。请勿通过陌生群消息、弹窗广告中的链接访问，谨防仿冒站点。',
  },
  {
    q: '地址多久更新一次？',
    a: '正常情况每 2 小时自动校验一次，并在页面顶部状态条展示可用数量与更新时间。',
  },
  {
    q: '需要注册或付费吗？',
    a: '本站仅提供入口指引与地址整理，不收取任何费用；如遇要求付费的页面，请立即退出并核对通道是否官方。',
  },
];

export const footerColumns = [
  {
    title: '快速导航',
    links: [
      { label: '官方入口', href: '#address' },
      { label: '最新地址', href: '#address' },
      { label: 'APP下载', href: '#app' },
      { label: '今日热议', href: '#trending' },
    ],
  },
  {
    title: '使用帮助',
    links: [
      { label: '新手指引', href: '#guide' },
      { label: '常见问题', href: '#guide' },
      { label: '通道状态', href: '#status' },
      { label: '吃瓜讨论', href: '#discussion' },
    ],
  },
];

export const footerDisclaimer =
  '本站为入口指引类页面，仅整理公开渠道信息，不存储、不制作、不传播任何内容。所有示例地址与数据仅作页面演示，请以官方公布信息为准。';